/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';

import {displayError} from '../../app/errorDisplayer';
import DataSourceDecoration from './DataSourceDecorationAdd.react';
import LoadingButton from '../../fw/LoadingButton.react';
import {FormattedMessage, injectIntl, IntlShape} from 'react-intl';
import {LoadingLine} from '../../loadingLine/renderLoadingPanel.react';
import './DataSourceRelation.scss';
import urlMapping from '../../app/URLMapping';
import types from '../../../common/model-api/types';
import config from '../../../common/config';
import {safeJSONparse} from "../../../common/util/safeJSONparse";

export const handlerName = "relation";

class DataSourceRelationAdd extends React.Component {

    static propTypes = {
        apply: PropTypes.func,
        dataSource: PropTypes.object,
        dataSourceToAdd: PropTypes.object,
        goBack: PropTypes.func,
        relay: PropTypes.object,
    };

    constructor(props) {
        super(props);
    }

    add = (entitySelectionRule) => {
        let newDataSource = {
            ...this.props.dataSourceToAdd,
        };

        let newEntitySelectionRule = types['entitySelectionRules'].defaultValues(newDataSource);
        newEntitySelectionRule.channelDef_id = entitySelectionRule.channelDef_id;
        newEntitySelectionRule.channel_id = entitySelectionRule.channel_id;
        newEntitySelectionRule.entityDef_id = entitySelectionRule.entityDef_id;
        newEntitySelectionRule.sourceDef_id = entitySelectionRule.sourceDef_id;

        newDataSource['entitySelectionRules'] = [newEntitySelectionRule];

        return this.props.apply(newDataSource);
    };

    showRelations(dataSource) {
        return (
            <div>
                <FormattedMessage defaultMessage="Choose relation:" id="DataSourceRelation.description" /><br/>

                <div className="btn-group-vertical DataSourceRelationGroup">{dataSource.allPossibleRelations.edges.map((node, idx) => {
                    let entityDef = node.node.entityDef;
                    let sourceDef = node.node.sourceDef;

                    return (
                        <LoadingButton className="btn btn-default" key={idx} onClick={this.add.bind(this, node.node)}>
                            <span aria-hidden="true" className="fa fa-plus fa-fw"></span>{" "}<span aria-hidden="true" className={"fa fa-fw " + entityDef.inheritedIcon}></span>{" "}{sourceDef.name}
                        </LoadingButton>
                    );
                })}</div>
            </div>
        );
    }

    showCachingLink(dataSource) {
        let hasAnyRelations = this.props.dataSource.channelDefs.find((channelDef) => {
            let metadata = safeJSONparse(channelDef.metadata);

            return metadata.hasAnyRelations;
        }) ? true : false;


        if (hasAnyRelations) {
            let channel = this.props.dataSource.channels.length > 0 ? this.props.dataSource.channels[0] : null;

            let type = types['channels'];
            let path = config.PUBLIC_APP_URL + urlMapping.getUrl(type, "caching", channel);

            return (
                <div>
                    <p><FormattedMessage defaultMessage="No relations available due to API limits. If you activate caching of data in {productName}, it is possible to handle more relations." id="DataSourceRelation.noRelationsCaching" values={{productName: config.PRODUCT_NAME}}/></p>

                    <a className="btn btn-default" href={path} target="_blank">
                        <span aria-hidden="true" className="fa fa-play"></span>{" "}<FormattedMessage defaultMessage="Go to caching activation" id="DataSourceRelation.activateCaching" />
                    </a>
                </div>
            );
        } else {
            return (
                <div>
                    <p><FormattedMessage defaultMessage="No relations available." id="DataSourceRelation.noRelations" /></p>

                    <button className="btn btn-default" onClick={this.props.goBack}>
                        <span aria-hidden="true" className="fa fa-plus fa-fw"></span>{" "}<FormattedMessage defaultMessage="Go Back" id="DataSourceRelation.goBack" />
                    </button>

                </div>
            );
        }
    }

    render() {
        let dataSourceToAdd = this.props.dataSourceToAdd;
        let dataSource = this.props.dataSource;

        try {
            return (
                <DataSourceDecoration
                    dataSource={dataSource}
                    dataSourceToAdd={dataSourceToAdd}
                    goBack={this.props.goBack}
                >

                    <div style={{padding: '2em'}}>
                        {dataSource && dataSource.allPossibleRelations ?
                            (
                                dataSource.allPossibleRelations.edges.length > 0 ?
                                this.showRelations(dataSource) :
                                this.showCachingLink(dataSource)
                            ) :
                            <LoadingLine />
                        }
                    </div>
                </DataSourceDecoration>
            );
        } catch (e) {
            displayError(e);
            return (<div>Error</div>);
        }
    }
}


export default Relay.createContainer(injectIntl(DataSourceRelationAdd), {
    initialVariables: {
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        dataSource: () => {
            return Relay.QL`
                fragment on DataSource {
                    id,
                    realId,
                    primaryEntityDef {
                        id,
                        realId
                    },
                    entityDefs {
                        id,
                        name
                    },
                    channelDefs {
                        id,
                        name,
                        metadata,
                        icon,
                    },
                    channels {
                        id,
                        realId,
                        organisation_id,
                        name,
                    },
                    allPossibleRelations(first: 100) {
                        edges {
                            node {
                                id,
                                realId,
                                entityDef_id,
                                entityDef {
                                    id,
                                    realId,
                                    name,
                                    inheritedIcon
                                },
                                channelDef_id,
                                channelDef {
                                    id,
                                    name,
                                    icon
                                },
                                sourceDef_id,
                                sourceDef {
                                    id,
                                    name,
                                },
                                channel_id
                            }
                        }
                    }
                }`;
        }
    }
});
